import { useState, useEffect, useCallback } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { api } from '../../../../api/Middleware';
import { API_URL } from '../../../../api/Urls';

// =============================================================================
// CRM PIPELINE PICKER (for data_collection with CRM management)
// =============================================================================
const CrmPipelinePicker = ({ config, onChange }) => {
  const [pipelines, setPipelines] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);

  const selectedPipelineId = config?.crm_pipeline_id || '';
  const selectedStageId = config?.crm_initial_stage_id || '';

  // Fetch pipelines
  const fetchPipelines = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(`${API_URL}pipelines/`);
      const data = response.data?.results || response.data || [];
      setPipelines(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching pipelines:', err);
      setPipelines([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch columns when pipeline changes
  const fetchColumns = useCallback(async (pipelineId) => {
    if (!pipelineId) {
      setColumns([]);
      return;
    }
    try {
      const response = await api.get(`${API_URL}columns/?pipeline=${pipelineId}`);
      const data = response.data?.results || response.data || [];
      setColumns(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error fetching columns:', err);
      setColumns([]);
    }
  }, []);

  useEffect(() => {
    fetchPipelines();
  }, [fetchPipelines]);

  useEffect(() => {
    if (selectedPipelineId) {
      fetchColumns(selectedPipelineId);
    }
  }, [selectedPipelineId, fetchColumns]);

  const handlePipelineChange = (e) => {
    const value = e.target.value;
    onChange('crm_pipeline_id', value);
    onChange('crm_initial_stage_id', '');
    if (value) {
      fetchColumns(value);
    } else {
      setColumns([]);
    }
  };

  const handleStageChange = (e) => {
    onChange('crm_initial_stage_id', e.target.value);
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '12px' }}>
        <Spinner animation="border" size="sm" style={{ color: '#6366f1' }} />
        <span style={{ marginLeft: '8px', color: '#666', fontSize: '13px' }}>Carregando pipelines...</span>
      </div>
    );
  }

  return (
    <div className="mb-3" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <div>
        <Form.Label style={{ fontWeight: 500, fontSize: '13px', color: '#94a3b8' }}>
          Pipeline do CRM
        </Form.Label>
        <Form.Select
          value={selectedPipelineId}
          onChange={handlePipelineChange}
          size="sm"
        >
          <option value="">Selecione o pipeline...</option>
          {pipelines.map((p) => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </Form.Select>
        <Form.Text className="text-muted" style={{ fontSize: '11px' }}>
          Pipeline onde novos contatos serão criados
        </Form.Text>
      </div>

      {selectedPipelineId && columns.length > 0 && (
        <div>
          <Form.Label style={{ fontWeight: 500, fontSize: '13px', color: '#94a3b8' }}>
            Estágio inicial
          </Form.Label>
          <Form.Select
            value={selectedStageId}
            onChange={handleStageChange}
            size="sm"
          >
            <option value="">Selecione o estágio...</option>
            {columns.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </Form.Select>
          <Form.Text className="text-muted" style={{ fontSize: '11px' }}>
            Estágio onde o contato será criado inicialmente
          </Form.Text>
        </div>
      )}
    </div>
  );
};

export default CrmPipelinePicker;
